import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  http: HttpClient;
  constructor(http: HttpClient) {
    this.http = http;
  }

  getCompanies() {
    return this.http.get('/Account/GetCompanies').toPromise();
  }

  login(loginData: any) {
    return this.http.post("/Account/Login",
    {
      actionModel: loginData
    }).toPromise();
  }

  windowsLogin(loginData: any) {
    return this.http.post("/Account/WindowsLogin", loginData).toPromise();
  }

  requestPasswordReset(employeeNum: number, prco: number, inputPin: string) {
    return this.http.post("/Account/RequestPasswordReset",
    {
      employee: employeeNum,
      pRCo: prco,
      inputPin: inputPin
    }).toPromise();
  }

  createAccount(accountData: any) {
    return this.http.post("/Account/Create",
      {
        actionModel: accountData
      }).toPromise();
  }

  checkReturnUrl(returnUrl: string) {
    return this.http.get("/Account/CheckReturnUrl?returnUrl=" + returnUrl).toPromise();
  }

  getCompanyNumFromUrl(coString: string) {
    return this.http.get("/Account/GetCompanyNumFromUrl?coString=" + coString).toPromise();
  }

  namedLogin(username: string, password: string) {
    return this.http.post("/Account/NamedLogin", { username: username, password: password }).toPromise();
  }

  getVistaTidEnabled() {
    return this.http.get("/Account/GetVistaTidEnabled").toPromise();
  }

  GetIsLoggedIn() {
    return this.http.get<boolean>("/Account/IsLoggedIn").toPromise();
  }   

  changePassword(requestObject: any) {
    var headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
    });
    var options = { headers: headers };
    let body = new URLSearchParams();
    body.set('employee', requestObject.employee);
    body.set('company', requestObject.company);
    body.set('oldPassword', requestObject.oldPassword);
    body.set('newPassword', requestObject.newPassword);
    return this.http.post("/Account/ChangePassword",
      body.toString(),
      options
    ).toPromise();
  }

  getEmployeeDetails(userKeyID?: number, employee?: number, company?: number) {
    return this.http.get("/Account/GetEmployeeDetails?userKeyID=" + userKeyID + "&employee=" + employee + "&company=" + company).toPromise();
  }

  resetPassword(userKeyId: number, inputPin: string, token: string, newPassword: string, confirmPassword: string) {
    return this.http.post("/Account/ResetPassword",
      {
        userKeyId: userKeyId,  
        inputPin: inputPin,
        token: token,
        newPassword: newPassword,
        confirmPassword: confirmPassword
      }).toPromise();
  }

  manualResetPassword(newPassword: string, confirmPassword: string, verificationPIN: number) {
    return this.http.post("/Account/ManualResetPassword",
      {   
        newPassword: newPassword,
        confirmPassword: confirmPassword,
        verificationPIN: verificationPIN
      }).toPromise();
  }

  async getPortalSettings (): Promise<PortalSettings> {
    return this.http.get<PortalSettings>('/Account/GetPortalSettings').toPromise();
  }

  async getAnonPortalSettings (): Promise<PortalSettings> {
    return this.http.get<PortalSettings>('/Account/GetPortalSettingsAnon').toPromise()
    }

    getJobsAccessToken() {
        return this.http.get("/Account/GetJobsAccessToken").toPromise();
    }

    getAccountLogoutRedirect() {
        var url = "/Account/Logout?noRedirect=true";
        return this.http.get(url, { responseType: 'text' }).toPromise();
    }
}

export interface PortalSettings {
  [key: string]: { ConfigValue: string | null};
}
